import { put } from 'redux-saga/effects'
import * as actions from '../actions';

export function* fetchPortForwardingSaga() {
    try {
        yield put(actions.setPortForwardingStartTime(new Date().getTime()));
        yield put(actions.initDevices({ withPortForwarding: true }));

        yield put(actions.portForwardingSuccess());

    } catch (error) {
        yield put(actions.portForwardingFail(error));
    }
}

export function* setNewDHCPReservationsSaga(action) {
    const rMac = yield sessionStorage.getItem('mac');
    const token = yield sessionStorage.getItem('token');
    const sessionToken = yield sessionStorage.getItem('sessionToken');
    if (sessionToken) {
      try {
        yield put(actions.setNewDHCPReservationsLoading())
       const response = yield axios.put(
          '/CreateNewDHCPIPReservation',
         {
          rMac, 
          ...action.payload || {}
         }
        )
        if (response?.status === 200) {
          yield put(actions.setNewDHCPReservationsSuccess(response?.data));
          
        }
        //  else {
        //   yield put(actions.SetNewDHCPReservationsFail());
        // }
      } catch (error) {
        yield put(actions.setNewDHCPReservationsFail(error));
      }
    }
  }
